import { render, staticRenderFns } from "./IsBankasiHGSApplicationSend.vue?vue&type=template&id=6635d767&"
import script from "./IsBankasiHGSApplicationSend.vue?vue&type=script&lang=js&"
export * from "./IsBankasiHGSApplicationSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports